/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import Input from "../../../component/inputpm";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import InputPhone from "../../../component/inputPhone";
import { withTranslation } from "react-i18next";
import Loader from "../../../component/loader";
import Button from "../../../component/button";
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import classes from "./customer.module.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import actionTypes from "../../../store/actions";
import { getStateName } from "../../../helper/getStateList.js";
import { TableContainer } from "@mui/material";

class BasicDetails extends Component {
  state = {
    loading: false,
    firstName: "",
    lastName: "",
    mobilePhone: "",
    officePhone: "",
    emailMechId: "",
    mobilePhoneMechId: "",
    officePhoneMechId: "",
    customersEmployeeList: [],
    billingCloseDay: "",

    showForm: false,
    days: [],
    profileData: {},
    loggedInUser: {},

    error: {},
  };

  componentDidMount() {
    this.setState(
      {
        profileData: this.props.profileData,
        loggedInUser: this.props.loggedInUser,
      },
      () => {},
    );
  }

  onChange = (e) => {
    this.props.setErrorMessage("", false);
    let profileData = { ...this.state.profileData };
    profileData[e.target.name] = e.target.value;
    this.setState({
      profileData,
    });
  };

  toggleGeneralInfoForm = () => {
    this.setState({
      showForm: !this.state.showForm,
      profileData: this.props.profileData,
    });
  };

  daysArray = () => {
    let days = [];
    for (let i = 1; i < 32; i++) {
      days.push("" + i);
    }
    return days;
  };

  validateForm = () => {
    const error = {};
    const { t } = this.props;
    if (!this.state.profileData.accountName) {
      error.accountName = t("ACCOUNT_NAME_IS_REQUIRED");
    }
    if (!this.state.profileData.officePhone) {
      error.officePhone = t("OFFICE_PHONE_IS_REQUIRED");
    } else if (!this.validateMobileNumber(this.state.profileData.officePhone)) {
      error.officePhone = t("PHONE_IS_INVALID");
    }
    if (!this.state.profileData.email) {
      error.email = t("EMAIL_IS_REQUIRED");
    } else if (!/\S+@\S+\.\S+/.test(this.state.profileData.email)) {
      error.email = t("EMAIL_IS_INVALID");
    }
    if (!this.state.profileData.billingCloseDay) {
      error.billingCloseDay = t("BILLING_CYCLE_IS_REQUIRED");
    }
    this.setState({ error });
    this.setState({
      loading: false,
    });
    if (Object.keys(error).length === 0) {
      return true;
    }
    // if (!this.state.profileData.accountName || !this.state.profileData.officePhone ||
    //     !this.state.profileData.email ||
    //     !this.state.profileData.billingCloseDay) {
    //     this.props.setErrorMessage(this.props.t('ALL_FIELDS_REQUIRED'), false);
    //     this.setState({
    //         loading: false
    //     })
    // } else {
    //     return true;
    // }
  };

  updateGeneralInfo = () => {
    this.setState({
      loading: true,
    });
    if (this.validateForm()) {
      let data = {
        contact: {
          firstName: "",
          lastName: "",
          partyId: "",
          officePhone: this.state.profileData.officePhone,
          mobilePhone: this.state.profileData.mobilePhone,
          email: this.state.profileData.email,
          emailMechId: this.state.profileData.emailMechId,
          mobilePhoneMechId: this.state.profileData.mobilePhoneMechId,
          officePhoneMechId: this.state.profileData.officePhoneMechId,
          billingCloseDay: this.state.profileData.billingCloseDay,
        },
        billing: {
          attention: "",
          phone: "",
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: "",
          country: "",
        },
        shipping: {
          attention: "",
          phone: "",
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: "",
          country: "",
        },
        banDetails: {
          accountName: this.state.profileData.accountName,
          ban: this.state.profileData.ban,
        },
      };
      this.submitData(data);
    }
  };

  submitData = (data) => {
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, data)
      .then((res) => {
        if (res.data.responseMessage === "success") {
          let prData = {
            officePhone: this.state.profileData.officePhone,
            mobilePhone: this.state.profileData.mobilePhone,
            email: this.state.profileData.email,
            billingCloseDay: this.state.profileData.billingCloseDay,
            accountName: this.state.profileData.accountName,
          };
          this.props.updateProfileData(prData);
          this.setState({
            showForm: !this.state.showForm,
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  validateMobileNumber = (mobileNumber) => {
    const mobileNumberRegex =
      /^[+]?[0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$|^[\+][1][-][0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$/;
    if (!mobileNumberRegex.test(mobileNumber)) {
      return false;
    }
    return true;
  };

  //render
  render() {
    const { t } = this.props;
    const { error } = this.state;
    const countriesList = this.props.countriesList;
    return (
      <div>
        {this.state.showForm ? (
          <Grid container spacing={3} style={{ marginTop: "15px" }}>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                error={!!error.accountName}
                helperText={error.accountName}
                variant={"outlined"}
                name={"accountName"}
                size={"small"}
                value={this.state.profileData.accountName}
                placeholder={t("ACCOUNT_NAME") + " *"}
                onChange={(event) => {
                  this.onChange(event);
                  this.setState({
                    error: {
                      ...this.state.error,
                      accountName: "",
                    },
                  });
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <InputPhone
                inputClass={classes.inputClass}
                error={!!error.officePhone}
                helperText={error.officePhone}
                variant={"outlined"}
                name={"officePhone"}
                size={"small"}
                value={this.state.profileData.officePhone}
                placeholder={t("OFFICE_PHONE") + " *"}
                onChange={(event) => {
                  this.onChange(event);
                  this.setState({
                    error: {
                      ...this.state.error,
                      officePhone: "",
                    },
                  });
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <InputPhone
                inputClass={classes.inputClass}
                variant={"outlined"}
                name={"mobilePhone"}
                size={"small"}
                placeholder={t("MOBILE_PHONE")}
                value={this.state.profileData.mobilePhone}
                onChange={(event) => {
                  this.onChange(event);
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                error={!!error.email}
                helperText={error.email}
                variant={"outlined"}
                name={"email"}
                size={"small"}
                value={this.state.profileData.email}
                placeholder={t("EMAIL") + " *"}
                onChange={(event) => {
                  this.onChange(event);
                  this.setState({
                    error: {
                      ...this.state.error,
                      email: "",
                    },
                  });
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <FormControl
                className="custom-select-input"
                size={"small"}
                variant={"outlined"}
                error={!!error.billingCloseDay}
              >
                <InputLabel htmlFor="outlined-age-native-simple">
                  {t("BILLING_CLOSE_DAY") + " *"}
                </InputLabel>
                <Select
                  native
                  label="BILLING_CLOSE_DAY"
                  value={this.state.profileData.billingCloseDay}
                  onChange={(event) => {
                    this.onChange(event);
                  }}
                  inputProps={{
                    name: "billingCloseDay",
                    id: "outlined-age-native-simple",
                  }}
                >
                  <option value="" disabled>
                    {t("BILLING_CLOSE_DAY") + " *"}
                  </option>
                  {this.daysArray().map((day) => (
                    <option key={day} value={day}>
                      {day}
                    </option>
                  ))}
                </Select>
                {error.billingCloseDay && (
                  <span
                    style={{
                      color: "#f44336",
                      marginLeft: "0px",
                      fontSize: "0.75rem",
                      marginTop: "4px",
                    }}
                  >
                    {error.billingCloseDay}
                  </span>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              align="right"
              size={{
                xs: 12,
              }}
            >
              <Button
                style={{ marginRight: "10px" }}
                onClick={() => this.toggleGeneralInfoForm()}
              >
                {t("CANCEL")}
              </Button>
              <Button onClick={() => this.updateGeneralInfo()}>
                {t("UPDATE")}
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Card>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <h3>
                        {t("GENERAL_INFORMATION")} -{" "}
                        {this.state.profileData.accountName}
                      </h3>
                    </TableCell>
                    <TableCell align="right">
                      {/* <Button onClick={() => this.toggleGeneralInfoForm()}>Edit</Button>
                                            <Button onClick={(e) => this.props.addChildItem(e, this.state.profileData.partyId)} style={{ marginLeft: '15px' }}>Add</Button> */}
                      {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && (
                        <Button onClick={() => this.toggleGeneralInfoForm()}>
                          {t("EDIT")}
                        </Button>
                      )}
                      {/* <Button style={{ marginLeft: '15px' }}>{t('ADD')}</Button> */}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{t("TENANT_NAME")}</TableCell>
                    <TableCell>{this.props.tenantData.title}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("ACCOUNT_NAME")}</TableCell>
                    <TableCell>{this.state.profileData.accountName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("ACCOUNT_NUMBER")}</TableCell>
                    <TableCell>{this.state.profileData.ban}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("SHIPPING_ADDRESS")}</TableCell>
                    {this.state.profileData.shipping &&
                    this.state.profileData.shipping.length > 0 ? (
                      <TableCell>
                        {this.state.profileData.shipping[0].street1},&nbsp;
                        {this.state.profileData.shipping[0].street2 &&
                          this.state.profileData.shipping[0].street2 !== "" &&
                          this.state.profileData.shipping[0].street2 + ", "}
                        {this.state.profileData.shipping[0].city},&nbsp;
                        {this.state.profileData.shipping[0].state}&nbsp;
                        {this.state.profileData.shipping[0].zipCode
                          ? this.state.profileData.shipping[0].zipCode
                          : this.state.profileData.shipping[0].zip}
                        ,&nbsp;
                        {this.state.profileData.shipping[0].country}
                      </TableCell>
                    ) : (
                      <TableCell></TableCell>
                    )}
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("CONTACT")}</TableCell>
                    <TableCell>
                      {this.state.profileData.firstName}{" "}
                      {this.state.profileData.lastName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("OFFICE_PHONE")}</TableCell>
                    <TableCell>{this.state.profileData.officePhone}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("MOBILE_PHONE")}</TableCell>
                    <TableCell>{this.state.profileData.mobilePhone}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("EMAIL")}</TableCell>
                    <TableCell>{this.state.profileData.email}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("BILLING_CLOSE_DAY")}</TableCell>
                    <TableCell>
                      {this.state.profileData.billingCloseDay}
                    </TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <h3>{t("PERSONAL_INFO")}</h3>
                    </TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{t("NAME")}</TableCell>
                    <TableCell>{this.state.loggedInUser.userName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("USERNAME")}</TableCell>
                    <TableCell>{this.state.loggedInUser.userId}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("EMAIL")}</TableCell>
                    <TableCell>{this.state.loggedInUser.email}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("USER_ROLE")}</TableCell>
                    <TableCell>{t(this.props.loggedInUserType)}</TableCell>
                  </TableRow>
                </TableBody>

                <TableHead>
                  <TableRow>
                    <TableCell>
                      <h3>{t("USERS")}</h3>
                    </TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.profileData.customersEmployeeList &&
                    this.state.profileData.customersEmployeeList.map(
                      (employe, index) => (
                        <>
                          <TableRow index={index}>
                            <TableCell>
                              {employe.firstName} {employe.lastName}
                            </TableCell>
                            <TableCell colSpan={1}>
                              {employe.email}
                              {/* <IconButton aria-label="expand row" style={{float: 'right'}} size="small">
                                        <KeyboardArrowUpIcon /> :  <KeyboardArrowDownIcon />
                                    </IconButton> */}
                            </TableCell>
                          </TableRow>
                        </>
                      ),
                    )}

                  {(this.state.profileData.customersEmployeeList ===
                    undefined ||
                    this.state.profileData.customersEmployeeList.length ===
                      0) && (
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        {t("NO_USERS_AVAILABLE")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>

                {/* Only for kore customer */}
                {/* <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <h3>Billing Address</h3>
                                        </TableCell>
                                        <TableCell align="right">&nbsp;</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        
                                    </TableRow>
                                </TableBody> */}
              </Table>
            </TableContainer>
          </Card>
        )}
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    roles: state.auth.roles,
    countriesList: state.global.countriesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(BasicDetails));
